import { ExpandMoreOutlined } from '@mui/icons-material';
import { Accordion, AccordionSummary, Typography, AccordionDetails, Box, Divider, LinearProgress, useTheme } from '@mui/material';
import { CompanyServices, ICompany } from '../../../services/api/company/CompanyServices';
import { useEffect, useState } from 'react';

interface CompanyConsolidated {
    uuid: string
}

export const CompanyConsolidated = ({uuid}: CompanyConsolidated) => {

    const [ data, setData ] = useState<ICompany>();
    const theme = useTheme();

    useEffect(() => {
        fetchData();
    }, [uuid]);

    const fetchData = () => {
        if(uuid){
            CompanyServices.getById(uuid)
                .then(response => {
                    if(response instanceof Error){
                        console.log(response.message);
                    }else{
                        setData(response);
                    }
                });
        }
    };

    if(data == undefined){
        return(
            <LinearProgress />
        );
    }

    return(
        <Accordion
            variant='outlined'
            square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
            <AccordionSummary
                expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
            >
                <Typography><strong>Dados do empreendedor</strong></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    <Typography>Razão Social:</Typography>
                    <Typography>{data?.company_name}</Typography>
                </Box>
                <Divider/>
                <Box flex={1} flexDirection={'column'} display={'flex'} gap={1}>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Rua:</Typography>
                        <Typography>{data?.rua}</Typography>
                        <Divider/>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Número:</Typography>
                        <Typography>{data?.numero}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Bairro:</Typography>
                        <Typography>{data?.bairro}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Cidade:</Typography>
                        <Typography>{data?.cidade}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>Estado:</Typography>
                        <Typography>{data?.estado}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>CEP:</Typography>
                        <Typography>{data?.cep}</Typography>
                    </Box>
                    <Box display={'flex'} flexDirection={'row'} gap={1}>
                        <Typography>País:</Typography>
                        <Typography>{data?.pais}</Typography>
                    </Box>
                </Box>
                <Divider/>
            </AccordionDetails>
        </Accordion>
    );
};